export default __webpack_public_path__ + "static/media/TX_Baba_1.cb0cf9ed.png";